module.exports = __webpack_public_path__ + "static/media/jared-tarbell-1.fbbf1c5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/jared-tarbell-1.jpg
// module id = 332
// module chunks = 11